import { getAIHook } from '@openclassrooms/data-connect-web/utils';

const useGenerateCoverLetter = getAIHook({
  promptCode: 'generate-cover-letter',
  serverName: 'ai-api-user',
});

export default useGenerateCoverLetter;
